export default "__VITE_ASSET__43eefca9__"